import { render, staticRenderFns } from "./RowTableCredits.vue?vue&type=template&id=e882c18a&scoped=true&"
import script from "./RowTableCredits.vue?vue&type=script&lang=js&"
export * from "./RowTableCredits.vue?vue&type=script&lang=js&"
import style0 from "./RowTableCredits.vue?vue&type=style&index=0&id=e882c18a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e882c18a",
  null
  
)

export default component.exports